<style lang="scss">
</style>

<template>
<div class="search-wrap">

    <article class="search-main clearfix">
        <div class="pull-left">
            <Button type="primary" @click="handleModal('init')">{{$t('erp.virtualstore.batchinittalization',{defaultValue:'批量初始化'})}}</Button>
        </div>
        <div class="pull-right">
            <Form :label-width="60" inline>
                <FormItem label='ERPSKU'>
                    <Input clearable v-model.trim="formData.erpSku"/>
                </FormItem>
                <FormItem :label="$t('global.common.project',{defaultValue:'项目'})">
                    <Select clearable v-model="formData.lineId" filterable >
                        <Option value="">All</Option>
                        <Option v-for="item in getNewDifferentAllProductList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                <FormItem :label="$t('global.common.warehouse',{defaultValue:'仓库'})">
                    <Select clearable v-model="formData.orgWarehouseId" filterable >
                        <Option value="">All</Option>
                        <Option v-for="item in warehouses" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                <FormItem :label-width="1">
                    <Button type="primary" @click="update" icon="ios-search">{{$t('global.common.search',{defaultValue:'搜索'})}}</Button>
                    <Button @click="reset" icon='md-refresh'>{{$t('erp.disturibution.reset_order',{defaultValue:'重置'})}}</Button>
                </FormItem>
            </Form>
        </div>
    </article>
</div>
</template>

<script>
import { mapState,mapGetters } from 'vuex'

export default {
    data() {
        return {
            formData: {
                erpSku: '',
                orgWarehouseId: '',
                lineId:'',
            },
        };
    },
    mounted() {
        this.update();
    },
    computed: {
         ...mapGetters('diction',['getNewDifferentAllProductList','getNewWarehouseIdList']),
        warehouses(){
            return this.getNewWarehouseIdList.filter(item=>{
                return item.attach.item.warehouseType !== 2 && item.attach.item.warehouseType !== 4
            })
        }
    },
    methods: {
        handleModal(type, id) {
            this.$parent.handleOperates(id, type);
        },
        update() {
            this.$emit('on-update', {
                // search: {
                    ...this.formData,
                // },
                page: 1
            });
        },
        reset() {
            this.formData = {
                erpSku: '',
                orgWarehouseId: '',
                lineId:'',
            };
            this.$emit('on-update', {
                // search: {
                    ...this.formData,
                // },
                page: 1,
            });
        },

    },
};
</script>
